import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/pages/home/index.vue'),
            children: [
                {
                    path: '/index',
                    name: 'index',
                    meta: { title: '首页' },
                    component: () => import('@/pages/index/index.vue')
                },
                {
                    path: '/indexs',
                    name: 'indexs',
                    meta: { title: '产品介绍' },
                    component: () => import('@/pages/indexs/index.vue')
                },
                {
                    path: '/aboutus',
                    name: 'aboutus',
                    meta: { title: '关于我们' },
                    component: () => import('@/aboutus/index/index.vue')
                }
            ]
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/404',
            name: '404',
            component: () => import('@/pages/404/index.vue')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js